var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllClassesText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 387.6 219",
    style: {
      enableBackground: "new 0 0 387.6 219"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.3391,
    y1: 297.9895,
    x2: 81.3391,
    y2: 127.9187,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.6,113h-49l-7.8,23.2H15.4L62.8,4.9h37l47.5,131.2h-33.8L105.6,113z M97.4,88.3l-16.3-48l-16.1,48H97.4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: -141.9622,
    cy: 524.1108,
    r: 1.5605,
    gradientTransform: "matrix(44.2101 0 0 -44.2102 6357.4868 23241.5801)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,4.9l47.5,131.2h-33.8l-7.8-23.2h-49l-7.8,23.2H15.4L62.8,4.9H99.8z M65.1,88.3h32.3l-16.3-48L65.1,88.3z  M101.7,2.3h-1.9h-37H61L60.4,4L12.9,135.2l-1.3,3.6h3.8h33.4h1.9l0.6-1.8l7.2-21.4h45.2L111,137l0.6,1.8h1.9h33.8h3.8l-1.3-3.6 L102.3,4L101.7,2.3z M68.8,85.6l12.4-37.1l12.5,37.1H68.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.2533,
    y1: 297.9895,
    x2: 211.2533,
    y2: 127.9187,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.6,111.5h67.2v24.7h-99.1V4.9h32V111.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: -140.9081,
    cy: 523.1921,
    r: 1.5605,
    gradientTransform: "matrix(38.9332 0 0 -38.9332 5697.2559 20440.0742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.6,4.9v106.5h67.2v24.7h-99.1V4.9H193.6z M196.3,2.3h-2.6h-32H159v2.6v131.2v2.6h2.6h99.1h2.6v-2.6v-24.7 v-2.6h-2.6h-64.5V4.9V2.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.3383,
    y1: 192.5411,
    x2: 81.3383,
    y2: 91.6741,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.5,70.3H91.3l6.1,18H65.1l6-18H39.2l-23.8,65.9h33.5l7.8-23.2h49l7.8,23.2h33.8L123.5,70.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.2299,
    y1: 192.5411,
    x2: 211.2299,
    y2: 91.6741,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193.6,111.5V70.3h-32v65.9h99.1v-24.7L193.6,111.5L193.6,111.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.9037,
    y1: 297.9895,
    x2: 326.9037,
    y2: 127.9187,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M309.3,111.5h67.2v24.7h-99.1V4.9h32V111.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: -139.841,
    cy: 523.1921,
    r: 1.5605,
    gradientTransform: "matrix(38.9332 0 0 -38.9332 5771.3599 20440.0742)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M309.3,4.9v106.5h67.2v24.7h-99.1V4.9H309.3z M311.9,2.3h-2.6h-32h-2.6v2.6v131.2v2.6h2.6h99.1h2.6v-2.6v-24.7 v-2.6h-2.6h-64.5V4.9V2.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.8818,
    y1: 192.5411,
    x2: 326.8818,
    y2: 91.6741,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M309.3,111.5V70.3h-32v65.9h99.1v-24.7L309.3,111.5L309.3,111.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.6539,
    y1: 105.6025,
    x2: 35.6539,
    y2: 25.1611,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M9.3,168.1c2.6-4.8,6.3-8.5,11.1-11.2c4.7-2.7,10.1-4,16.1-4c7.4,0,13.7,1.9,18.9,5.8 c5.2,3.9,8.7,9.2,10.5,15.9H49.4c-1.2-2.6-3-4.6-5.3-5.9c-2.3-1.3-4.9-2-7.7-2c-4.7,0-8.4,1.6-11.3,4.9c-2.9,3.2-4.3,7.6-4.3,13 c0,5.4,1.4,9.8,4.3,13c2.9,3.2,6.7,4.9,11.3,4.9c2.9,0,5.5-0.7,7.7-2c2.3-1.4,4-3.3,5.3-5.9H66c-1.8,6.7-5.3,12-10.5,15.9 c-5.2,3.9-11.5,5.8-18.9,5.8c-6,0-11.4-1.3-16.1-4c-4.7-2.7-8.4-6.4-11.1-11.2c-2.6-4.8-4-10.2-4-16.3 C5.3,178.4,6.7,172.9,9.3,168.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: -143.9645,
    cy: 514.4371,
    r: 1.5604,
    gradientTransform: "matrix(20.7028 0 0 -20.7028 3016.3059 10834.7402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M36.5,152.9c7.4,0,13.7,1.9,18.9,5.8c5.2,3.9,8.7,9.2,10.5,15.9H49.4c-1.2-2.6-3-4.6-5.3-5.9 c-2.3-1.3-4.9-2-7.7-2c-4.7,0-8.4,1.6-11.3,4.9c-2.9,3.2-4.3,7.6-4.3,13c0,5.4,1.4,9.8,4.3,13c2.9,3.2,6.7,4.9,11.3,4.9 c2.9,0,5.5-0.7,7.7-2c2.3-1.4,4-3.3,5.3-5.9H66c-1.8,6.7-5.3,12-10.5,15.9c-5.2,3.9-11.5,5.8-18.9,5.8c-6,0-11.4-1.3-16.1-4 c-4.7-2.7-8.4-6.4-11.1-11.2c-2.6-4.8-4-10.2-4-16.3c0-6.1,1.3-11.6,4-16.4c2.6-4.8,6.3-8.5,11.1-11.2 C25.1,154.2,30.5,152.9,36.5,152.9z M36.5,151.6c-6.2,0-11.8,1.4-16.7,4.2c-4.9,2.8-8.8,6.7-11.6,11.7c-2.7,5-4.1,10.7-4.1,17 c0,6.3,1.4,12,4.1,17c2.8,5,6.6,8.9,11.6,11.7c4.9,2.8,10.5,4.2,16.7,4.2c7.6,0,14.2-2,19.7-6c5.5-4,9.2-9.6,11-16.6l0.4-1.6H66 H49.4h-0.8l-0.3,0.7c-1.1,2.4-2.7,4.2-4.8,5.4c-2.1,1.2-4.4,1.9-7.1,1.9c-4.3,0-7.7-1.4-10.4-4.4c-2.7-3-4-7.1-4-12.2 c0-5.1,1.3-9.2,4-12.2c2.7-3,6.1-4.4,10.4-4.4c2.6,0,5,0.6,7.1,1.9c2,1.2,3.7,3,4.8,5.4l0.3,0.7h0.8H66h1.6l-0.4-1.6 c-1.8-7-5.5-12.5-11-16.6C50.7,153.7,44.1,151.6,36.5,151.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.7127,
    y1: 105.6025,
    x2: 92.7127,
    y2: 25.1611,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.4,203.9h19.8v11.7H75.3v-62h15.1V203.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: -143.4461,
    cy: 510.7371,
    r: 1.5603,
    gradientTransform: "matrix(16.904 0 0 -16.904 2517.5229 8818.0801)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.4,153.6v50.4h19.8v11.7H75.3v-62H90.4z M91.6,152.3h-1.3H75.3H74v1.3v62v1.3h1.3h34.9h1.2v-1.3v-11.7 v-1.3h-1.2H91.6v-49.1V152.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.5397,
    y1: 105.6025,
    x2: 144.5397,
    y2: 25.1611,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M156,204.7h-23.2l-3.7,11h-15.8l22.4-62h17.5l22.4,62h-16L156,204.7z M152.1,193l-7.7-22.7l-7.6,22.7H152.1z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: -142.0656,
    cy: 514.5984,
    r: 1.5607,
    gradientTransform: "matrix(20.911 0 0 -20.911 3115.2998 10945.3555)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M153.3,153.6l22.4,62h-16l-3.7-11h-23.2l-3.7,11h-15.8l22.4-62H153.3z M136.9,193h15.3l-7.7-22.7L136.9,193z  M154.2,152.3h-0.9h-17.5h-0.9l-0.3,0.8l-22.4,62l-0.6,1.7h1.8h15.8h0.9l0.3-0.9l3.4-10.1h21.4l3.4,10.1l0.3,0.9h0.9h16h1.8 l-0.6-1.7l-22.4-62L154.2,152.3z M138.6,191.7l5.9-17.5l5.9,17.5H138.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.2111,
    y1: 105.6041,
    x2: 204.2111,
    y2: 25.1611,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M192.8,214c-3.6-1.5-6.5-3.7-8.6-6.5c-2.2-2.9-3.3-6.4-3.4-10.4h16.1c0.2,2.3,1,4,2.4,5.3 c1.3,1.2,3.1,1.8,5.3,1.8c2.2,0,4-0.5,5.3-1.5c1.3-1,1.9-2.5,1.9-4.3c0-1.5-0.5-2.8-1.5-3.8c-1-1-2.3-1.8-3.8-2.5 c-1.5-0.6-3.6-1.4-6.4-2.2c-4-1.2-7.3-2.5-9.8-3.7c-2.5-1.2-4.7-3.1-6.5-5.5c-1.8-2.4-2.7-5.6-2.7-9.5c0-5.8,2.1-10.3,6.3-13.6 c4.2-3.3,9.6-4.9,16.3-4.9c6.8,0,12.3,1.6,16.5,4.9c4.2,3.3,6.4,7.8,6.7,13.7h-16.3c-0.1-2-0.9-3.6-2.2-4.7 c-1.4-1.2-3.1-1.7-5.2-1.7c-1.8,0-3.3,0.5-4.4,1.5c-1.1,1-1.7,2.4-1.7,4.2c0,2,0.9,3.6,2.8,4.7c1.9,1.1,4.8,2.3,8.8,3.6 c4,1.4,7.3,2.6,9.8,3.9c2.5,1.2,4.7,3,6.5,5.4c1.8,2.4,2.7,5.4,2.7,9.1c0,3.5-0.9,6.7-2.7,9.6c-1.8,2.9-4.4,5.2-7.8,6.9 c-3.4,1.7-7.4,2.6-12.1,2.6C200.5,216.2,196.4,215.5,192.8,214z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: -141.0588,
    cy: 512.6608,
    r: 1.5603,
    gradientTransform: "matrix(18.6854 0 0 -18.6854 2839.9451 9763.7217)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M203.6,152.7c6.8,0,12.3,1.6,16.5,4.9c4.2,3.3,6.4,7.8,6.7,13.7h-16.3c-0.1-2-0.9-3.6-2.2-4.7 c-1.4-1.2-3.1-1.7-5.2-1.7c-1.8,0-3.3,0.5-4.4,1.5c-1.1,1-1.7,2.4-1.7,4.2c0,2,0.9,3.6,2.8,4.7c1.9,1.1,4.8,2.3,8.8,3.6 c4,1.4,7.3,2.6,9.8,3.9s4.7,3,6.5,5.4c1.8,2.4,2.7,5.4,2.7,9.1c0,3.5-0.9,6.7-2.7,9.6c-1.8,2.9-4.4,5.2-7.8,6.9 c-3.4,1.7-7.5,2.6-12.1,2.6c-4.5,0-8.6-0.7-12.2-2.2c-3.6-1.5-6.5-3.7-8.6-6.5c-2.2-2.9-3.3-6.4-3.4-10.4h16.1c0.2,2.3,1,4,2.4,5.3 c1.3,1.2,3.1,1.8,5.3,1.8c2.2,0,4-0.5,5.3-1.5c1.3-1,1.9-2.5,1.9-4.3c0-1.5-0.5-2.8-1.5-3.8c-1-1-2.3-1.8-3.8-2.5 c-1.5-0.6-3.6-1.4-6.4-2.2c-4-1.2-7.3-2.5-9.8-3.7c-2.5-1.2-4.7-3.1-6.5-5.5c-1.8-2.4-2.7-5.6-2.7-9.5c0-5.8,2.1-10.3,6.3-13.6 C191.4,154.3,196.9,152.7,203.6,152.7z M203.6,151.4c-7,0-12.7,1.7-17.1,5.2c-4.5,3.5-6.8,8.4-6.8,14.6c0,4.1,1,7.6,3,10.2 c1.9,2.6,4.3,4.5,7,5.9c2.6,1.3,6,2.5,10,3.8c2.7,0.8,4.8,1.5,6.3,2.2c1.3,0.6,2.5,1.3,3.4,2.2c0.8,0.8,1.2,1.7,1.2,2.9 c0,1.4-0.5,2.5-1.5,3.3c-1.1,0.8-2.6,1.3-4.5,1.3c-1.9,0-3.3-0.5-4.5-1.5c-1.1-1-1.8-2.5-2-4.5l-0.1-1.1h-1.1h-16.1h-1.3l0,1.3 c0.1,4.3,1.3,8.1,3.7,11.1c2.3,3.1,5.4,5.4,9.1,7c3.7,1.5,8,2.3,12.7,2.3c4.8,0,9.1-0.9,12.7-2.7c3.6-1.8,6.4-4.3,8.3-7.4 c1.9-3.1,2.9-6.5,2.9-10.3c0-4-1-7.3-3-9.9c-1.9-2.5-4.3-4.4-6.9-5.7c-2.5-1.3-5.9-2.6-9.9-3.9c-3.9-1.3-6.8-2.5-8.6-3.5 c-1.5-0.9-2.2-2-2.2-3.6c0-1.5,0.4-2.5,1.2-3.3c0.9-0.8,2.1-1.2,3.6-1.2c1.8,0,3.3,0.5,4.4,1.4c1.1,0.9,1.7,2.2,1.8,3.8l0.1,1.2 h1.2h16.3h1.3l-0.1-1.3c-0.3-6.2-2.7-11.1-7.2-14.6C216.5,153.2,210.7,151.4,203.6,151.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.5717,
    y1: 105.6041,
    x2: 258.5717,
    y2: 25.1611,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M247.2,214c-3.6-1.5-6.5-3.7-8.6-6.5c-2.2-2.9-3.3-6.4-3.4-10.4h16.1c0.2,2.3,1,4,2.4,5.3 c1.3,1.2,3.1,1.8,5.3,1.8c2.2,0,4-0.5,5.3-1.5c1.3-1,1.9-2.5,1.9-4.3c0-1.5-0.5-2.8-1.5-3.8c-1-1-2.3-1.8-3.8-2.5 c-1.5-0.6-3.6-1.4-6.4-2.2c-4-1.2-7.3-2.5-9.8-3.7c-2.5-1.2-4.7-3.1-6.5-5.5c-1.8-2.4-2.7-5.6-2.7-9.5c0-5.8,2.1-10.3,6.3-13.6 c4.2-3.3,9.6-4.9,16.3-4.9c6.8,0,12.3,1.6,16.5,4.9c4.2,3.3,6.4,7.8,6.7,13.7h-16.3c-0.1-2-0.9-3.6-2.2-4.7 c-1.4-1.2-3.1-1.7-5.2-1.7c-1.8,0-3.3,0.5-4.4,1.5c-1.1,1-1.7,2.4-1.7,4.2c0,2,0.9,3.6,2.8,4.7c1.9,1.1,4.8,2.3,8.8,3.6 c4,1.4,7.3,2.6,9.8,3.9c2.5,1.2,4.7,3,6.5,5.4c1.8,2.4,2.7,5.4,2.7,9.1c0,3.5-0.9,6.7-2.7,9.6c-1.8,2.9-4.4,5.2-7.8,6.9 c-3.4,1.7-7.4,2.6-12.1,2.6C254.8,216.2,250.8,215.5,247.2,214z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: -140.0137,
    cy: 512.6608,
    r: 1.5604,
    gradientTransform: "matrix(18.6854 0 0 -18.6854 2874.7759 9763.7217)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M258,152.7c6.8,0,12.4,1.6,16.5,4.9c4.2,3.3,6.4,7.8,6.7,13.7h-16.3c-0.1-2-0.9-3.6-2.2-4.7 c-1.4-1.2-3.1-1.7-5.2-1.7c-1.8,0-3.3,0.5-4.4,1.5c-1.1,1-1.7,2.4-1.7,4.2c0,2,0.9,3.6,2.8,4.7c1.9,1.1,4.8,2.3,8.8,3.6 c4,1.4,7.3,2.6,9.8,3.9c2.5,1.2,4.7,3,6.5,5.4c1.8,2.4,2.7,5.4,2.7,9.1c0,3.5-0.9,6.7-2.7,9.6c-1.8,2.9-4.4,5.2-7.8,6.9 c-3.4,1.7-7.4,2.6-12.1,2.6c-4.5,0-8.6-0.7-12.2-2.2c-3.6-1.5-6.5-3.7-8.6-6.5c-2.2-2.9-3.3-6.4-3.4-10.4h16.1c0.2,2.3,1,4,2.4,5.3 c1.3,1.2,3.1,1.8,5.3,1.8c2.2,0,4-0.5,5.3-1.5c1.3-1,1.9-2.5,1.9-4.3c0-1.5-0.5-2.8-1.5-3.8c-1-1-2.3-1.8-3.8-2.5 c-1.5-0.6-3.6-1.4-6.4-2.2c-4-1.2-7.3-2.5-9.8-3.7c-2.5-1.2-4.7-3.1-6.5-5.5c-1.8-2.4-2.7-5.6-2.7-9.5c0-5.8,2.1-10.3,6.3-13.6 C245.8,154.3,251.2,152.7,258,152.7z M258,151.4c-7,0-12.7,1.7-17.1,5.2c-4.5,3.5-6.8,8.4-6.8,14.6c0,4.1,1,7.6,3,10.2 c1.9,2.6,4.3,4.5,7,5.9c2.6,1.3,6,2.5,10,3.8c2.7,0.8,4.8,1.5,6.3,2.2c1.3,0.6,2.5,1.3,3.4,2.2c0.8,0.8,1.2,1.7,1.2,2.9 c0,1.4-0.5,2.5-1.5,3.3c-1.1,0.8-2.6,1.3-4.5,1.3c-1.9,0-3.3-0.5-4.5-1.5c-1.1-1-1.8-2.5-2-4.5l-0.1-1.1h-1.1h-16.1h-1.3l0,1.3 c0.1,4.3,1.3,8.1,3.7,11.1c2.3,3.1,5.4,5.4,9.1,7c3.7,1.5,8,2.3,12.7,2.3c4.8,0,9.1-0.9,12.7-2.7c3.6-1.8,6.4-4.3,8.3-7.4 c1.9-3.1,2.9-6.5,2.9-10.3c0-4-1-7.3-3-9.9c-1.9-2.5-4.3-4.4-6.9-5.7c-2.5-1.3-5.9-2.6-9.9-3.9c-3.9-1.3-6.8-2.5-8.6-3.5 c-1.5-0.9-2.2-2-2.2-3.6c0-1.5,0.4-2.5,1.3-3.3c0.9-0.8,2.1-1.2,3.6-1.2c1.8,0,3.3,0.5,4.4,1.4c1.1,0.9,1.7,2.2,1.8,3.8l0.1,1.2 h1.2h16.3h1.3l-0.1-1.3c-0.3-6.2-2.7-11.1-7.2-14.6C270.9,153.2,265,151.4,258,151.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2777,
    y1: 105.601,
    x2: 310.2777,
    y2: 25.1595,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M306.4,165.7v12.5h20.2v11.7h-20.2v13.6h22.9v12.1h-38v-62h38v12.1L306.4,165.7L306.4,165.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: -138.8658,
    cy: 511.1597,
    r: 1.5603,
    gradientTransform: "matrix(17.2661 0 0 -17.2661 2707.9478 9010.3154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M329.3,153.6v12.1h-22.9v12.5h20.2v11.7h-20.2v13.6h22.9v12.1h-38v-62L329.3,153.6 M330.5,152.3h-1.3h-38H290 v1.3v62v1.3h1.2h38h1.3v-1.3v-12.1v-1.3h-1.3h-21.6v-11.1h19h1.3v-1.3v-11.7V177h-1.3h-19v-10h21.6h1.3v-1.3v-12.1V152.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.7306,
    y1: 105.6041,
    x2: 360.7306,
    y2: 25.1611,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M349.3,214c-3.6-1.5-6.5-3.7-8.6-6.5c-2.2-2.9-3.3-6.4-3.4-10.4h16.1c0.2,2.3,1,4,2.4,5.3 c1.3,1.2,3.1,1.8,5.3,1.8c2.2,0,4-0.5,5.3-1.5c1.3-1,1.9-2.5,1.9-4.3c0-1.5-0.5-2.8-1.5-3.8c-1-1-2.3-1.8-3.8-2.5 c-1.5-0.6-3.6-1.4-6.4-2.2c-4-1.2-7.3-2.5-9.8-3.7c-2.5-1.2-4.7-3.1-6.5-5.5c-1.8-2.4-2.7-5.6-2.7-9.5c0-5.8,2.1-10.3,6.3-13.6 c4.2-3.3,9.6-4.9,16.3-4.9c6.8,0,12.4,1.6,16.5,4.9c4.2,3.3,6.4,7.8,6.7,13.7H367c-0.1-2-0.9-3.6-2.2-4.7c-1.4-1.2-3.1-1.7-5.2-1.7 c-1.8,0-3.3,0.5-4.4,1.5c-1.1,1-1.7,2.4-1.7,4.2c0,2,0.9,3.6,2.8,4.7c1.9,1.1,4.8,2.3,8.8,3.6c4,1.4,7.3,2.6,9.8,3.9 c2.5,1.2,4.7,3,6.5,5.4c1.8,2.4,2.7,5.4,2.7,9.1c0,3.5-0.9,6.7-2.7,9.6c-1.8,2.9-4.4,5.2-7.8,6.9c-3.4,1.7-7.4,2.6-12.1,2.6 C357,216.2,352.9,215.5,349.3,214z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_23_",
    cx: -138.05,
    cy: 512.6608,
    r: 1.5604,
    gradientTransform: "matrix(18.6854 0 0 -18.6854 2940.2449 9763.7217)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#124985"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D5583"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M360.1,152.7c6.8,0,12.3,1.6,16.5,4.9c4.2,3.3,6.4,7.8,6.7,13.7H367c-0.1-2-0.9-3.6-2.2-4.7 c-1.4-1.2-3.1-1.7-5.2-1.7c-1.8,0-3.3,0.5-4.4,1.5c-1.1,1-1.7,2.4-1.7,4.2c0,2,0.9,3.6,2.8,4.7c1.9,1.1,4.8,2.3,8.8,3.6 c4,1.4,7.3,2.6,9.8,3.9c2.5,1.2,4.7,3,6.5,5.4c1.8,2.4,2.7,5.4,2.7,9.1c0,3.5-0.9,6.7-2.7,9.6c-1.8,2.9-4.4,5.2-7.8,6.9 c-3.4,1.7-7.4,2.6-12.1,2.6c-4.5,0-8.6-0.7-12.2-2.2c-3.6-1.5-6.5-3.7-8.6-6.5c-2.2-2.9-3.3-6.4-3.4-10.4h16.1c0.2,2.3,1,4,2.4,5.3 c1.3,1.2,3.1,1.8,5.3,1.8c2.2,0,4-0.5,5.3-1.5c1.3-1,1.9-2.5,1.9-4.3c0-1.5-0.5-2.8-1.5-3.8c-1-1-2.3-1.8-3.8-2.5 c-1.5-0.6-3.6-1.4-6.4-2.2c-4-1.2-7.3-2.5-9.8-3.7c-2.5-1.2-4.7-3.1-6.5-5.5c-1.8-2.4-2.7-5.6-2.7-9.5c0-5.8,2.1-10.3,6.3-13.6 C347.9,154.3,353.4,152.7,360.1,152.7z M360.1,151.4c-7,0-12.7,1.7-17.1,5.2c-4.5,3.5-6.8,8.4-6.8,14.6c0,4.1,1,7.6,3,10.2 c1.9,2.6,4.3,4.5,7,5.9c2.6,1.3,6,2.5,10,3.8c2.7,0.8,4.8,1.5,6.3,2.2c1.3,0.6,2.5,1.3,3.4,2.2c0.8,0.8,1.2,1.7,1.2,2.9 c0,1.4-0.5,2.5-1.5,3.3c-1.1,0.8-2.6,1.3-4.5,1.3c-1.9,0-3.3-0.5-4.5-1.5c-1.1-1-1.8-2.5-2-4.5l-0.1-1.1h-1.1h-16.1H336l0,1.3 c0.1,4.3,1.3,8.1,3.7,11.1c2.3,3.1,5.4,5.4,9.1,7c3.7,1.5,8,2.3,12.7,2.3c4.8,0,9.1-0.9,12.7-2.7c3.6-1.8,6.4-4.3,8.3-7.4 c1.9-3.1,2.9-6.5,2.9-10.3c0-4-1-7.3-3-9.9c-1.9-2.5-4.3-4.4-6.9-5.7c-2.5-1.3-5.9-2.6-9.9-3.9c-3.9-1.3-6.8-2.5-8.6-3.5 c-1.5-0.9-2.2-2-2.2-3.6c0-1.5,0.4-2.5,1.3-3.3c0.9-0.8,2.1-1.2,3.6-1.2c1.8,0,3.3,0.5,4.4,1.4c1.1,0.9,1.7,2.2,1.8,3.8l0.1,1.2 h1.2h16.3h1.3l-0.1-1.3c-0.3-6.2-2.7-11.1-7.2-14.6C373,153.2,367.2,151.4,360.1,151.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.6726,
    y1: 55.7333,
    x2: 35.6726,
    y2: 8.0225,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M49.4,194.4c-1.2,2.6-3,4.6-5.3,5.9c-2.3,1.3-4.9,2-7.7,2c-4.7,0-8.4-1.6-11.3-4.9c-2.9-3.2-4.3-7.6-4.3-13v0 H5.3v0c0,6.1,1.3,11.6,4,16.3c2.7,4.8,6.3,8.5,11.1,11.2c4.8,2.7,10.1,4,16.1,4c7.4,0,13.7-1.9,18.9-5.8c5.2-3.9,8.8-9.2,10.5-15.9 L49.4,194.4L49.4,194.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.6948,
    y1: 55.7302,
    x2: 92.6948,
    y2: 8.0209,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M90.3,203.9v-19.5H75.2v31.2h34.9v-11.7L90.3,203.9L90.3,203.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.5421,
    y1: 55.7302,
    x2: 144.5421,
    y2: 8.0209,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M164.5,184.5h-15.2l2.9,8.5h-15.3l2.9-8.5h-15.1l-11.3,31.2h15.8l3.7-11H156l3.7,11h16L164.5,184.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.1963,
    y1: 55.7302,
    x2: 204.1963,
    y2: 8.0209,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M224.9,188c-1.1-1.4-2.3-2.6-3.6-3.6h-33.8c0.9,0.6,1.7,1.2,2.7,1.6c2.5,1.2,5.8,2.5,9.8,3.7 c2.8,0.8,4.9,1.6,6.4,2.2c1.5,0.7,2.8,1.5,3.8,2.5c1,1,1.5,2.3,1.5,3.8c0,1.8-0.7,3.3-1.9,4.3c-1.3,1-3.1,1.6-5.3,1.6 c-2.2,0-3.9-0.6-5.3-1.8c-1.3-1.2-2.2-3-2.4-5.2h-16.1c0.1,4.1,1.3,7.5,3.4,10.4c2.2,2.9,5,5.1,8.6,6.5c3.6,1.5,7.6,2.2,12.2,2.2 c4.6,0,8.7-0.9,12.1-2.6c3.4-1.7,6-4,7.8-6.9c1.8-2.9,2.7-6.1,2.7-9.6C227.6,193.4,226.7,190.4,224.9,188z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.5592,
    y1: 55.7302,
    x2: 258.5592,
    y2: 8.0209,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M279.2,188c-1.1-1.4-2.3-2.6-3.6-3.6h-33.8c0.9,0.6,1.7,1.2,2.7,1.6c2.5,1.2,5.8,2.5,9.8,3.7 c2.8,0.8,4.9,1.6,6.4,2.2c1.5,0.7,2.8,1.5,3.8,2.5c1,1,1.5,2.3,1.5,3.8c0,1.8-0.7,3.3-1.9,4.3c-1.3,1-3.1,1.6-5.3,1.6 c-2.2,0-3.9-0.6-5.3-1.8c-1.3-1.2-2.2-3-2.4-5.2h-16.1c0.1,4.1,1.2,7.5,3.4,10.4c2.2,2.9,5,5.1,8.6,6.5c3.6,1.5,7.6,2.2,12.2,2.2 c4.6,0,8.7-0.9,12.1-2.6c3.4-1.7,6-4,7.8-6.9c1.8-2.9,2.7-6.1,2.7-9.6C282,193.4,281.1,190.4,279.2,188z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.2684,
    y1: 55.7333,
    x2: 310.2684,
    y2: 8.0225,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M306.4,203.5v-13.6h20.2v-5.4h-35.4v31.2h38v-12.1L306.4,203.5L306.4,203.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.754,
    y1: 55.7302,
    x2: 360.754,
    y2: 8.0209,
    gradientTransform: "matrix(1 0 0 -1 0 219.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020203"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#20305A"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M381.4,188c-1.1-1.4-2.3-2.6-3.6-3.6h-33.8c0.9,0.6,1.8,1.2,2.7,1.6c2.5,1.2,5.8,2.5,9.8,3.7 c2.8,0.8,4.9,1.6,6.4,2.2c1.5,0.7,2.8,1.5,3.8,2.5c1,1,1.6,2.3,1.6,3.8c0,1.8-0.7,3.3-2,4.3c-1.3,1-3.1,1.6-5.3,1.6 c-2.2,0-4-0.6-5.3-1.8c-1.3-1.2-2.1-3-2.4-5.2h-16.1c0.1,4.1,1.2,7.5,3.4,10.4c2.1,2.9,5,5.1,8.6,6.5c3.6,1.5,7.7,2.2,12.2,2.2 c4.7,0,8.7-0.9,12.1-2.6c3.4-1.7,6-4,7.8-6.9c1.8-2.9,2.7-6.1,2.7-9.6C384.2,193.4,383.3,190.4,381.4,188z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllClassesText);
export default __webpack_public_path__ + "static/media/AllClassesText.3c1af234936f0688d46f171f078b6ec1.svg";
export { ForwardRef as ReactComponent };